export enum ESupplyType {
  FUEL = 'FUEL',
  REPAIR_LARGE = 'REPAIR_LARGE',
  REPAIR_SMALL = 'REPAIR_SMALL',
  ASSETS_LARGE = 'ASSETS_LARGE',
  ASSETS_SMALL = 'ASSETS_SMALL'
}
export enum ESupplySubType {
  MOOC = 'MOOC',
  OIL = 'OIL',
  WHEEL = 'WHEEL',
  GENERATOR = 'GENERATOR',
  CONTAINER = 'CONTAINER',
  CHARGE = 'CHARGE'
}
export enum ESupplyStatus {
  INACTIVE = -1,
  DEFAULT = 0,
  ACTIVE = 1,
  DISABLE = 3
}
export enum ESupplyDocumentType {
  FUEL = 'FUEL',
  REPAIR_LARGE = 'REPAIR_LARGE',
  REPAIR_SMALL = 'REPAIR_SMALL',
  ASSETS_LARGE = 'ASSETS_LARGE',
  ASSETS_SMALL = 'ASSETS_SMALL'
}
export enum ESupplyDocumentPrivacy {
  PRIVACY = 0,
  ALL = 1,
  ONLYME = 2
}
export interface ISupply {
  ID: string
  name: string
  price: number
  type: ESupplyType
  subType: ESupplySubType
  vendor: string
  weightKG: number
  status: ESupplyStatus
  description: string
  depreciationMonth: number
  priceLiquidation: number
  usedTotal: number
}

export interface ISupplyPlugin {
  ID: string
  name: string
  supply: string
  plugin: string
  status: ESupplyStatus
  description: string
}

export interface ISupplyInsurance {
  ID: string
  supply: string
  vendor: string
  amount: number
  expiredDate: string
  description: string
}

export interface ISupplyDocument {
  ID: string
  title: string
  supply: string
  type: ESupplyDocumentType
  url: string
  description: string
  privacy: ESupplyDocumentPrivacy
}
